import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export const fetchCoaches = async () => {
  try {
    const response = await axios.get(`${API_URL}/coaches`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchCoach = async (id) => {
  try {
    const response = await axios.get(`${API_URL}/coaches/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createCoach = async (coachData) => {
  try {
    const response = await axios.post(`${API_URL}/coaches`, coachData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateCoach = async (id, coachData) => {
  try {
    const response = await axios.put(`${API_URL}/coaches/${id}`, coachData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteCoach = async (id) => {
  try {
    await axios.delete(`${API_URL}/coaches/${id}`);
  } catch (error) {
    throw error;
  }
};

export const searchCoaches = async (query) => {
  try {
    const response = await axios.get(`${API_URL}/coaches/search`, {
      params: { query }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}; 